import { render, staticRenderFns } from "./toggle-register-or-login.vue?vue&type=template&id=cab2b866&scoped=true&"
import script from "./toggle-register-or-login.vue?vue&type=script&lang=js&"
export * from "./toggle-register-or-login.vue?vue&type=script&lang=js&"
import style0 from "./toggle-register-or-login.vue?vue&type=style&index=0&id=cab2b866&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab2b866",
  null
  
)

export default component.exports